exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".oa-cell .icon-center[data-v-d75e19c2]{margin-right:8px;font-size:24px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-d75e19c2&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobileDetail/attachmentCell.vue
// module id = 502
// module chunks = 0